export type ToggleTypeCategoryItem = {
    id: string;
    name: string;
};

export type ToggleTypeListItem = {
    id: string;
    title: string;
    contents: string;
    categoryId: string;
};

export const TOGGLE_TYPE_ALL_CATEGORY_ID = 'all';
